import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选专题</h2>
          <div className="w-12 h-1 bg-primary-500 mx-auto rounded-full"></div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.slice(0, 3).map((card) => (
            <a key={card.id} href="#" className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="relative h-48 overflow-hidden">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">{card.tag}</span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {cardsData.slice(3).map((card) => (
            <a key={card.id} href="#" className="group flex flex-col sm:flex-row bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="relative sm:w-48 h-40 sm:h-auto flex-shrink-0 overflow-hidden">
                <img src={card.image} alt={card.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">{card.tag}</span>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{card.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}